import qs from "query-string";
import Cookies from "js-cookie";

import { publicConfig } from "@lululemon/ecom-core";
import * as atgApi from "@lululemon/ecom-common/src/services/atg";

/* istanbul ignore next */
export const getWishlistSkuFromQueryParam = () => {
  const {
    url,
    query: { wishlistSku, ...restParams },
  } = qs.parseUrl(globalThis.window?.location.href || "");

  if (wishlistSku) {
    const stringified = qs.stringify(restParams);
    const stringifiedQuestionMark = stringified
      ? `?${stringified}`
      : stringified;
    const urlWithoutWishlistSku = `${url}${stringifiedQuestionMark}`;

    // Remove wishlistSku query param from url for cleaning it up.
    // wishlistSku is just needed for adding the item to wishlist after the user returns from the login page.
    globalThis.window?.history.pushState({}, "", urlWithoutWishlistSku);
  }

  return wishlistSku;
};

export const getSkuDetails = (sku) => {
  const {
    color: { code: color } = {},
    inseam,
    productId,
    size,
    styleNumber,
    styleId: styleOption,
  } = sku || {};
  const countryCode = Cookies.get("sl");
  // Return without undefined values
  return {
    ...(color && { color }),
    ...(inseam && { inseam }),
    ...(productId && { productId }),
    ...(size && { size }),
    ...(styleNumber && { styleNumber }),
    ...(styleOption && { styleOption }),
    ...(countryCode && { countryCode }),
    loadProductData: true,
  };
};

export const checkOktaExpiration = (errors) =>
  Array.isArray(errors) &&
  errors.some((err) => {
    const errorCode = err?.extensions?.errorCode;
    return errorCode === "403000" || errorCode === "missingOktaAccessToken";
  });

// It's an expected log/404 when a guest has an empty WL and is interacting for the first time.
// This could improperly inflating the error rate
export const checkEmptyWLException = (errors) =>
  Array.isArray(errors) &&
  errors.some((err) => {
    const errorCode = err?.extensions?.errorCode;
    return errorCode !== "404001";
  });

/**
 * @returns {string}
 */
export const getCNEGraphqlEndpoint = () => {
  const apiHost = `${publicConfig?.apiHost}`;
  const KIWI_PATH = "/cne/graphql";
  return `${apiHost}${KIWI_PATH}`;
};

/**
 * @param breadCrumbs
 * @returns {*[]}
 */
export const formatPdpBreadcrumbs = (breadCrumbs = {}) => {
  if (!breadCrumbs) {
    return [];
  }
  const ancestors = breadCrumbs?.ancestors?.map((crumb) => {
    // ['navigation-state'] to be deprecated when pdp migrates
    // from legacyPDPResponse to the productDetailPage graphql query
    const navigationState =
      crumb?.["navigation-state"] || crumb?.navigationState || null;
    return {
      label: crumb?.label,
      "content-path": null,
      "navigation-state": navigationState,
      url: `https://${atgApi.getHostName()}${navigationState}`,
    };
  });
  if (!ancestors?.length && !breadCrumbs?.label) {
    return [];
  }
  const { properties, label } = breadCrumbs;
  const navigationState =
    properties?.["navigation-state"] || properties?.navigationState || null;
  return [
    ...(ancestors || []),
    {
      label,
      "content-path": null,
      "navigation-state": navigationState,
      url: `https://${atgApi.getHostName()}${navigationState}`,
    },
  ];
};
